.rv-score-chart-container {
  display: flex;
  flex-direction: row;
}
